/* eslint-disable no-useless-escape */

export const SelectMenuTypes = {
  SINGLE_SELECTION: 'singleSelection',
  MULTI_SELECTION: 'multiSelection',
  FOLDER_SINGLE_SELECTION: 'folderSingleSelection',
  FOLDER_MULTI_SELECTION: 'folderMultiSelection'
};
export const SelectOptionTypes = {
  GROUP_LIST: 'groupList',
  FOLDER_LIST: 'folderList'
};
export const defaultSelectedValue = placeHolder => ({
  label: placeHolder,
  value: ''
});
export const removePlaceholder = function () {
  let selectedValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let placeHolder = arguments.length > 1 ? arguments[1] : undefined;
  return selectedValues.filter(_ref => {
    let {
      label
    } = _ref;
    return label != placeHolder;
  });
};
export const getContainerHeight = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let isInsideFolder = arguments.length > 1 ? arguments[1] : undefined;
  let isMultiSelection = arguments.length > 2 ? arguments[2] : undefined;
  let isGrouped = arguments.length > 3 ? arguments[3] : undefined;
  let containerHeight = 0;
  if (isMultiSelection) {
    containerHeight += 49; // 49px is the height of select all row in multi selection selectmenu
  }
  if (isGrouped) {
    containerHeight += 40;
  }
  let i = 0;
  const maxHeight = isInsideFolder ? 223 : 291;
  // 223 = 307 - 84
  // 307px is the max height set for the list body container (ul).
  // 84px is the height of the folder title row inside the folder section that includes bottom padding and margin.
  // 291 = 307 - 16.
  // 16px is 8px + 8px of top and bottom padding each added to the list body container.

  while (i < options.length && containerHeight <= maxHeight) {
    if (options[i].type === SelectOptionTypes.GROUP_LIST) {
      containerHeight += getContainerHeight(options[i].items, false, false, true);
    } else {
      containerHeight += options[i].helpText ? 60 : 40; // 60px is the height of a row with helpText
      // 40px is the height of a row without helpText.
    }
    i++;
  }
  return containerHeight > maxHeight ? maxHeight : containerHeight;
};